import { Drawer, Tooltip } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { IoCloseSharp } from "react-icons/io5";
import { RiFileList3Line } from "react-icons/ri";
import RightBarPos from "../../components/RightBarPos";
import PageName from "../../components/react_helmet/PageName";
import SaleOrderHeader from "../../components/sections/saleOrderSections/SaleOrderHeader";
import SalesOrderTable from "../../components/table/SalesOrderTable";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
import useSales from "./customHooks/useSales";

const SaleOrders = (props) => {
  const {
    setSelectedOrderStatus,
    setSelectedPaymentStatus,
    searchValue,
    setSearchValue,
    setCanSearch,
    orders,
    selectedData,
    setSelectedData,
    selectedOrderStatus,
    dateRange, setDateRange, handleCriticalOrderClick, showCriticalOrders, gettingOrders,
    selectedDate, setSelectedDate, user, sale_orders, totalPages, currentPage, itemsPerPage, setItemsPerPage, loading, setLoading, setCurrentPage, criticalOrdersCount,
    sortOrder, setSortOrder
  } = useSales(props);

  const { layout } = useSelector((state) => state.redux);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isRecentPoOpen, setIsRecentPoOpen] = useState(true);

  return (
    <>
      <PageName title={"Sale Orders"} />

      <Row className="position-relative g-0">
        <Col md={layout === "navbar" && isRecentPoOpen ? 9 : 12} className={layout === "navbar" && isRecentPoOpen ? "pe-3" : ""}>
          <SaleOrderHeader
            setSelectedOrderStatus={setSelectedOrderStatus}
            setSelectedPaymentStatus={setSelectedPaymentStatus}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            setCanSearch={setCanSearch}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            selectedOrderStatus={selectedOrderStatus}
            user={user}
            dateRange={dateRange}
            setDateRange={setDateRange}
            length={totalPages}
            handleCriticalOrderClick={handleCriticalOrderClick}
            selectedDate={selectedDate} setSelectedDate={setSelectedDate}
            showCriticalOrders={showCriticalOrders}
            criticalOrders={criticalOrdersCount}
            loading={loading}
            gettingOrders={gettingOrders}
            toggleDrawer={() => setDrawerOpen(true)}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            isRecentPoOpen={isRecentPoOpen}
            toggleNavbarDrawer={() => setIsRecentPoOpen(!isRecentPoOpen)}
          />

          {loading ? (
            <TableSkeleton columns={8} />
          ) : (
            <SalesOrderTable
              selectedOrderStatus={selectedOrderStatus}
              setSelectedData={setSelectedData}
              setSelectedOrderStatus={setSelectedOrderStatus}
              sale_orders={orders ?? []}
              user={user}
              searchValue={searchValue}
              showCriticalOrders={showCriticalOrders}
              totalPages={totalPages}
              page={currentPage}
              pageSize={itemsPerPage}
              setPage={setCurrentPage}
              setPageSize={setItemsPerPage}
              onClearSearch={searchValue ? () => {
                setSearchValue("");
                setCurrentPage(1);
              } : undefined}
            />
          )}
        </Col>

        {layout === "navbar" ? (
          isRecentPoOpen && (
            <Col md={3} className="bg-white" style={{
              height: 'calc(100vh - 100px)',
              position: 'sticky',
              top: '0',
              overflowY: 'auto',
              borderLeft: '1px solid #e9ecef'
            }}>
              <div className="p-3 border-bottom bg-light sticky-top d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <RiFileList3Line className="text-primary" size={18} />
                  <h5 className="mb-0 fw-bold fs-16">Recent Purchase Orders</h5>
                </div>
                <Tooltip title="Collapse Panel">
                  <button
                    type="button"
                    className="btn btn-sm btn-light p-1 rounded-circle d-flex align-items-center justify-content-center text-secondary border-0"
                    style={{ width: '28px', height: '28px', cursor: 'pointer' }}
                    onClick={() => setIsRecentPoOpen(false)}
                    aria-label="Collapse Recent POs Panel"
                  >
                    <IoCloseSharp size={18} />
                  </button>
                </Tooltip>
              </div>
              <div style={{ height: 'auto' }}>
                <RightBarPos />
              </div>
            </Col>
          )
        ) : (
          <Drawer
            title={
              <div className="d-flex align-items-center gap-2 fw-bold fs-16">
                <RiFileList3Line className="text-primary" size={18} />
                <span>Recent Purchase Orders</span>
              </div>
            }
            placement="right"
            onClose={() => setDrawerOpen(false)}
            open={drawerOpen}
            width={400}
            bodyStyle={{ padding: 0 }}
          >
            <div style={{ height: '100%' }}>
              <RightBarPos />
            </div>
          </Drawer>
        )}
      </Row>
    </>
  );
};

export default SaleOrders;
